import React from 'react';
import { StarIcon } from 'lucide-react';
const TESTIMONIALS = [{
  text: 'Llevaba 3 años gritando cada mañana. La primera semana con el Tomo 2 tuve la mañana más tranquila de mi vida como mamá.',
  author: 'Luciana M.',
  role: 'mamá de 2 hijos',
  color: 'bg-pink-100 text-pink-700'
}, {
  text: 'No sabía cómo manejar las rabietas de mi nena de 4 años. El Tomo 3 me cambió la vida literalmente. Ahora sé exactamente qué hacer.',
  author: 'Romina T.',
  role: 'mamá de 3',
  color: 'bg-purple-100 text-purple-700'
}, {
  text: 'Pensé que era otro e-book más. Pero es un sistema real. Empecé a ver cambios en 4 días.',
  author: 'Valeria G.',
  role: 'mamá primeriza',
  color: 'bg-blue-100 text-blue-700'
}, {
  text: 'El Mapa de Triggers me abrió los ojos. Nunca había pensado en mis propios disparadores. Eso lo cambió todo.',
  author: 'Carolina B.',
  role: 'mamá de mellizos',
  color: 'bg-green-100 text-green-700'
}, {
  text: 'Por fin un método que no me pide ser perfecta. Me pide ser consciente. Eso sí puedo.',
  author: 'Mariana S.',
  role: 'mamá de 3 hijos',
  color: 'bg-orange-100 text-orange-700'
}];
export function TestimonialsSection() {
  return <section className="py-20 px-4 bg-slate-50 border-y border-slate-200" data-id="element-230">
      <div className="max-w-5xl mx-auto" data-id="element-231">
        <div className="text-center mb-16" data-id="element-232">
          <h2 className="text-3xl md:text-4xl font-black text-slate-900 mb-4" data-id="element-233">
            💬 ESTO DICEN LAS MAMÁS QUE YA LO TIENEN
          </h2>
          <div className="flex justify-center gap-1" data-id="element-234">
            {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-8 h-8 text-yellow-400 fill-yellow-400" data-id="element-235" />)}
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-236">
          {TESTIMONIALS.map((t, idx) => <div key={idx} className={`bg-white p-8 rounded-2xl shadow-md border border-slate-100 flex flex-col ${idx === 4 ? 'md:col-span-2 lg:col-span-1 lg:col-start-2' : ''}`} data-id="element-237">
              <div className="flex gap-1 mb-4" data-id="element-238">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 text-yellow-400 fill-yellow-400" data-id="element-239" />)}
              </div>
              <p className="text-slate-700 italic text-lg mb-6 flex-1" data-id="element-240">
                "{t.text}"
              </p>
              <div className="flex items-center gap-4 mt-auto pt-4 border-t border-slate-50" data-id="element-241">
                <div className={`w-12 h-12 rounded-full flex items-center justify-center font-bold text-lg ${t.color}`} data-id="element-242">
                  {t.author.charAt(0)}
                </div>
                <div data-id="element-243">
                  <p className="font-bold text-slate-900" data-id="element-244">{t.author}</p>
                  <p className="text-sm text-slate-500" data-id="element-245">{t.role}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}